import React from 'react';
import './FallingFlowers.css';

const FLOWER_TYPES = [
  /* Cherry blossom / 5-petal */
  (props) => (
    <svg className="flower-svg" viewBox="0 0 40 40" {...props}>
      <circle cx="20" cy="20" r="3" fill="#fff8f0" />
      <ellipse cx="20" cy="8" rx="6" ry="10" fill="#ffb7c5" transform="rotate(0 20 20)" />
      <ellipse cx="20" cy="8" rx="6" ry="10" fill="#ffb7c5" transform="rotate(72 20 20)" />
      <ellipse cx="20" cy="8" rx="6" ry="10" fill="#ffb7c5" transform="rotate(144 20 20)" />
      <ellipse cx="20" cy="8" rx="6" ry="10" fill="#ffb7c5" transform="rotate(216 20 20)" />
      <ellipse cx="20" cy="8" rx="6" ry="10" fill="#ffb7c5" transform="rotate(288 20 20)" />
    </svg>
  ),
  /* Simple 5-petal peach */
  (props) => (
    <svg className="flower-svg" viewBox="0 0 40 40" {...props}>
      <circle cx="20" cy="20" r="4" fill="#f9e189" />
      <path d="M20 6 Q24 14 20 20 Q16 14 20 6" fill="#fee7c7" />
      <path d="M20 6 Q26 18 20 20 Q14 18 20 6" fill="#fee7c7" transform="rotate(72 20 20)" />
      <path d="M20 6 Q26 18 20 20 Q14 18 20 6" fill="#fee7c7" transform="rotate(144 20 20)" />
      <path d="M20 6 Q26 18 20 20 Q14 18 20 6" fill="#fee7c7" transform="rotate(216 20 20)" />
      <path d="M20 6 Q26 18 20 20 Q14 18 20 6" fill="#fee7c7" transform="rotate(288 20 20)" />
    </svg>
  ),
  /* Small dot flower */
  (props) => (
    <svg className="flower-svg" viewBox="0 0 32 32" {...props}>
      <circle cx="16" cy="16" r="5" fill="#fff1b6" />
      <circle cx="16" cy="10" r="3" fill="#ffc33f" />
      <circle cx="22" cy="14" r="3" fill="#ffc33f" />
      <circle cx="22" cy="22" r="3" fill="#ffc33f" />
      <circle cx="16" cy="26" r="3" fill="#ffc33f" />
      <circle cx="10" cy="22" r="3" fill="#ffc33f" />
      <circle cx="10" cy="14" r="3" fill="#ffc33f" />
    </svg>
  ),
  /* Rose-like */
  (props) => (
    <svg className="flower-svg" viewBox="0 0 40 40" {...props}>
      <circle cx="20" cy="20" r="2" fill="#fdf8f2" />
      <ellipse cx="20" cy="12" rx="8" ry="12" fill="#e8a0a0" transform="rotate(-20 20 20)" />
      <ellipse cx="20" cy="12" rx="8" ry="12" fill="#e8a0a0" transform="rotate(52 20 20)" />
      <ellipse cx="20" cy="12" rx="8" ry="12" fill="#e8a0a0" transform="rotate(124 20 20)" />
      <ellipse cx="20" cy="12" rx="8" ry="12" fill="#e8a0a0" transform="rotate(196 20 20)" />
      <ellipse cx="20" cy="12" rx="8" ry="12" fill="#e8a0a0" transform="rotate(268 20 20)" />
    </svg>
  ),
  /* Tiny blossom */
  (props) => (
    <svg className="flower-svg" viewBox="0 0 24 24" {...props}>
      <circle cx="12" cy="12" r="2" fill="#fffef9" />
      <circle cx="12" cy="6" r="2.5" fill="#ffb7c5" />
      <circle cx="16.4" cy="8.4" r="2.5" fill="#ffb7c5" />
      <circle cx="16.4" cy="15.6" r="2.5" fill="#ffb7c5" />
      <circle cx="12" cy="18" r="2.5" fill="#ffb7c5" />
      <circle cx="7.6" cy="15.6" r="2.5" fill="#ffb7c5" />
      <circle cx="7.6" cy="8.4" r="2.5" fill="#ffb7c5" />
    </svg>
  ),
];

const COUNT = 28;

function FallingFlowers() {
  const flowers = Array.from({ length: COUNT }, (_, i) => {
    const FlowerComponent = FLOWER_TYPES[i % FLOWER_TYPES.length];
    const left = (i * 7 + (i % 5) * 11) % 100;
    const duration = 18 + (i % 7) * 2 + (i % 3);
    const delay = (i * 0.8 + (i % 4) * 2) % 12;
    const size = 12 + (i % 5) * 4 + (i % 3) * 2;
    const sway = 15 + (i % 4) * 8;
    return (
      <div
        key={i}
        className="falling-flower"
        style={{
          '--flower-left': `${left}%`,
          '--flower-duration': `${duration}s`,
          '--flower-delay': `-${delay}s`,
          '--flower-size': `${size}px`,
          '--flower-sway': `${sway}px`,
        }}
        aria-hidden="true"
      >
        <FlowerComponent />
      </div>
    );
  });

  return <div className="falling-flowers-container">{flowers}</div>;
}

export default FallingFlowers;
